import { React, useEffect, useState } from "react";
import GlobalLoadingSpinner from "../../components/GlobalLoadingSpinner";
import { TextField } from "@mui/material";
import { api } from "../../utils/api";
import TransactionTable from "./TrarnsactionTable";
import TransactionTablePaginated from "./TransactionTablePaginated";
import { useBasicSearch } from "../../hooks/useBasicSearch";

const Transaction = () => {
  const [transactionItems, setTransactionItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showTransactionForm, setShowTransactionForm] = useState(false);
  const { filteredData, search, setSearch } = useBasicSearch(transactionItems);
  const selectedPortal = sessionStorage.getItem("selectedPortal");
  const isAdminPortal = selectedPortal === "Administrator";

  useEffect(() => {
    fetchTransactions();
  }, []);

  const fetchTransactions = async () => {
    try {
      // For admin portal, let TransactionTablePaginated handle its own data fetching with pagination
      if (isAdminPortal) {
        setTransactionItems([]); // Empty array to trigger server-side pagination
        setLoading(false);
        return;
      }

      // For partner portal, use the existing logic
      let response;
      switch (selectedPortal) {
        case "Partner":
          let idPartnerCompany = sessionStorage.getItem("selectedCompany");
          response = await api(`v1/partner/company/${idPartnerCompany}/transactions`, "GET");
          break;
        default:
          response = null;
          break;
      }

      if (response && response.data.success) {
        setTransactionItems(response.data.data.allTransactions);
      }
    } catch (error) {
      console.error("API error:", error);
    }
    setLoading(false);
  };

  const triggerTransactionListUpdate = (transaction) => {
    console.log("New/Updated Transaction: ", transaction);
    setShowTransactionForm(false);
    setLoading(false);
    fetchTransactions();
  };

  return (
    <div className="page transaction flex w-full flex-column items-center p-4">
      {loading && <GlobalLoadingSpinner />}
      <div className="pageTitle flex flex-col w-full text-center lg:flex-row lg:text-left lg:justify-between mb-4">
        <h2>Transactions</h2>
        {!isAdminPortal && (
          <div>
            <TextField
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              sx={{ marginRight: "6px", width: "400px" }}
              variant="outlined"
              size="small"
              placeholder="Search for a transaction"
            />
          </div>
        )}
      </div>
      <div className="flex w-full">
        {/* <div className="pageActions">
              <Button variant="contained" onClick={() => setShowTransactionForm(true)}>
                Add New Transaction
              </Button>
              <ModalPopup
                showModal={showTransactionForm}
                handleShowModal={() => setShowTransactionForm(false)}
                popupTitle="Add New Transaction Option"
                popupContent={<TransactionForm callback={triggerTransactionListUpdate} />}
              />
            </div> */}
        {isAdminPortal ? (
          <TransactionTablePaginated transactions={[]} />
        ) : (
          filteredData.length > 0 && <TransactionTable transactions={filteredData} />
        )}
      </div>
    </div>
  );
};

export default Transaction;
